import { render, staticRenderFns } from "./total.m.vue?vue&type=template&id=345503fe&scoped=true"
import script from "./total.m.vue?vue&type=script&lang=js"
export * from "./total.m.vue?vue&type=script&lang=js"
import style0 from "./total.m.vue?vue&type=style&index=0&id=345503fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345503fe",
  null
  
)

export default component.exports